import { api } from "./api";

export interface HelpSection {
  title: string;
  roles: string[];
  steps: string[];
}

export interface HelpArticle {
  screen: string;
  title: string;
  sections: HelpSection[];
}

export function helpForRoles(
  articles: HelpArticle[],
  roles: string[],
  all = false,
): HelpArticle[] {
  return articles.flatMap((article) => {
    const sections = article.sections.filter(
      (section) =>
        all ||
        roles.includes("superadmin") ||
        section.roles.includes("*") ||
        section.roles.some((role) => roles.includes(role)),
    );
    return sections.length ? [{ ...article, sections }] : [];
  });
}

export function searchHelp(
  articles: HelpArticle[],
  query: string,
): HelpArticle[] {
  const normalize = (text: string) =>
    text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[đĐ]/g, "d")
      .toLocaleLowerCase("hr");
  const term = normalize(query.trim());
  return articles.flatMap((article) => {
    if (normalize(article.title).includes(term)) return [article];
    const sections = article.sections.filter((section) =>
      normalize([section.title, ...section.steps].join(" ")).includes(term),
    );
    return sections.length ? [{ ...article, sections }] : [];
  });
}

export const help = {
  articles: async (signal: AbortSignal) =>
    (await api.get<HelpArticle[]>("/support/help", { signal })).data,
  pdf: async (all: boolean) =>
    (
      await api.get<Blob>("/support/help/pdf", {
        params: { all_roles: all },
        responseType: "blob",
      })
    ).data,
};
